import React from 'react';
import { ListItem } from 'material-ui/List';

export default function ListItemInput(props) {
  return <ListItem innerDivStyle={{ padding: '0 4px' }} disabled {...props} />;
}



// WEBPACK FOOTER //
// ./components/atoms/ListItemInput.js